// Libraries
import { OnInit } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';
import * as _ from 'lodash';

/**
 * `Paginable` implements a concern to manage pagination.
 */
export abstract class Paginable implements OnInit {
  // Public properties
  /**
   * Current page.
   */
  currentPage = 1;
  /**
   * Per page.
   */
  perPage = 10;
  /**
   * Total count.
   */
  totalCount = 0;

  // Private properties
  /**
   * Storage prefix
   */
  private storagePrefix: String = 'pagination';
  /**
   * Save pagination
   */
  private savePagination: boolean;

  /**
   * Creates a new `Paginable` instance.
   * @param _localStorageService Service to manage local storage
   * @param sPrefix Prefix to save pagination
   * @param sPagination Save or not pagination
   */
  constructor(
    protected localStorageService: LocalStorageService,
    private sPrefix: String,
    private sPagination: boolean
  ) {
    this.storagePrefix = this.sPrefix;
    this.savePagination = this.sPagination;
  }

  // Public methods
  /**
   * On init method
   */
  ngOnInit(): void {
    // Check if save pagination
    if (this.savePagination) {
      // Get current page from local storage
      this.getCurrentPage();
    }
  }

  /**
   * Handles on page change event.
   * @param currentPage Current page
   */
  onPageChange(currentPage: number): void {
    this.currentPage = currentPage;
    if (this.savePagination) {
      // Save current page on local storage
      this.saveCurrentPage();
    }
  }

  /**
   * Copy pagination data from meta object
   * @param meta Meta object
   * @return True if need refresh current page
   */
  copyMetaData(meta: any): boolean {
    let update = false;
    if (meta) {
      // Check if current page is smaller than total pages
      if (meta.currentPage > meta.totalPages) {
        this.currentPage = 1;
        if (this.savePagination) {
          // Save current page on local storage
          this.saveCurrentPage();
        }
        update = true;
      } else {
        this.currentPage = parseInt(meta.currentPage, 10);
      }
      // Copy meta data
      this.totalCount = meta.totalCount;
      this.perPage = meta.perPage;
    } else {
      this.totalCount = 0;
      this.currentPage = 0;
    }

    return update;
  }

  // Private methods
  /**
   * Save current page on local storage
   */
  private saveCurrentPage(): void {
    // Save value on local storage
    this.localStorageService.set(this.storagePrefix + '-current-page', this.currentPage);
  }

  /**
   * Get current page from local storage
   */
  private getCurrentPage() {
    let currentPage = parseInt(this.localStorageService.get<string>(this.storagePrefix + '-current-page'), 10);
    // Check if current page saved is number, then trigger page change event
    if (!_.isNaN(currentPage) && this.currentPage !== currentPage) {
      this.currentPage = currentPage;
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/woopa-ui/pagination/paginable.ts